import othersList from './List'
import othersShow from './Show'
import othersEdit from './Edit'

const othersResource = {
  list: othersList,
  show: othersShow,
  edit: othersEdit,
}

export default othersResource
